// Auto generated by ControleTool.ModelClassGenerator
import { inject } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { Helpers } from '../services/helpers';
import { AnswerViewModel } from './answerview-model';


export class AnswerSelectedFieldViewModel {
    id: number = 0;
	answerId: number = 0;
	answer: AnswerViewModel = null;
	selectedField: string = null;
	createdOn: Date = new Date();
	modifiedOn: Date | null = null;
	
	constructor(data: any = null) {
        
		if (data) {
			Helpers.mapProperties(data, this);
        }
        
	}
}